import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CoinAsset } from '../../models/common/coin-asset';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStoreService } from '../../services/app-store.service';
import { CoinListService } from '../../services/coin-list.service';
import { coinLibrary } from 'src/app/models/common/coinLibrary';
import { AssetDataService } from 'src/app/services/asset-data.service';

@Component({
  selector: 'app-coin-card',
  templateUrl: './coin-card.component.html',
  styleUrls: ['./coin-card.component.scss']
})
export class CoinCardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('coinCardContainer') coinCardContainer: ElementRef;

  @Input() coin: CoinAsset;
  @Input() mobile = false;

  active = false;
  subscription: Subscription;
  subscription2: Subscription;
  interval;
  random;

  priceIncrease: boolean;

  constructor(
    private router: Router,
    public appStore: AppStoreService,
    private coinListService: CoinListService,
    public assetDataService: AssetDataService,
  ) { }

  ngOnInit(): void {
    if (window.innerWidth > 480) {
      this.initSelectedAssetCheck();
    }
    this.random = Math.floor(Math.random() * (4) + 3) * 1000;
    this.interval = setInterval(() => {
      const coinRef = this.coinListService.data.find(item => this.coin.id === item.id);
      let random = (Math.floor((Math.random() * 6) + 1));
      const plusOrMinus = Math.random() < 0.5 ? -1 : 1;
      random = random * plusOrMinus;
      const negative = coinRef.price + random;

      this.priceIncrease = negative > coinRef.price;
      negative < 0 ? (coinRef.price = ((coinRef.price + random) * -1)) : coinRef.price += random;
    }, this.random);
  }

  ngAfterViewInit(): void {
    this.coinCardContainer.nativeElement.addEventListener('animationend', () => {
      this.priceIncrease = null;
      this.coinCardContainer.nativeElement.classList.remove('increase', 'decrease');
    });
  }

  initSelectedAssetCheck() {
    if (this.coin) {
      this.active = this.router.url.split('/')[2].toUpperCase() === this.coin.id.toUpperCase() ? true : false;
      this.subscription = this.appStore.selectedAsset.subscribe((res: string) => {
        this.active = res.toUpperCase() === this.coin.id.toUpperCase() ? true : false;
      });
    }
  }

  onClick() {
    this.getCoinInfo(this.coin.id);
    // this.appStore.setSelectedAsset(this.coin.id); i think this is redundant - leave here for a bit before removing just in case
    const pair = this.coin.id.toUpperCase();
    this.saveRoute(pair);
    this.router.navigate(['/dashboard', pair]);
  }

  getCoinInfo(id: string) {
    this.subscription2 = this.coinListService.getCoinInfo(id).subscribe((res: any) => {
      this.appStore.setSelectedAssetInfo(res);
    });
  }

  saveRoute(pair: string) {
    localStorage.setItem('empowerLastVisited', pair);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.subscription2?.unsubscribe();
    clearInterval(this.interval);
  }
}
